import { useMsalRoles } from './useMsalRoles';

export const useIsSuperUser = () => {
    const roles = useMsalRoles();
    return roles.includes('superuser');
};
